import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { AuthenticationWarning } from '../components';
import { RenewToken, CancelTimeoutWarning, InitialisationHelper, EModalType, Logout } from '../helpers';

class AuthenticationWarningContainer extends React.Component<any, any> {

    closeDialog = () => {
        RenewToken();

        if(this.props.state.timeoutPassed) {
            Logout();
            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }
        else {
            store.dispatch({ type: types.TOGGLE_DIALOG, openModal: EModalType.None });
        }
    }

    public render() {

        let { state } = this.props;

        return <AuthenticationWarning timeoutPassed={state.timeoutPassed} closeDialog={this.closeDialog} />;
    }

}

let mapStateToProps = (store) => {
	
	return {
		state: store.authenticationState
    };
    
};

export default connect<any, any, any>(mapStateToProps)(AuthenticationWarningContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/authentication-warning.tsx